export default {
    data() {
        return {
            params: {},
            multiSort: false,
            defaultSort: null,
            tableHeight: null,
            pageSizes: [20, 50, 100, 150],
            totalCount: 0,
            loading: false,
            page: {
                page_number: 1,
                page_size: 20
            },
            fetchParams: {},
            startPickerOptions: {
                disabledDate: this.disableStartDate
            },
            endPickerOptions: {
                disabledDate: this.disableEndDate
            },
            collapseSearch: false,
            multipleSelection: [],
        }
    },
    created() {
        this.fetchParams = this.filterParams({
            ...this.params,
            ...this.page,
        });
        this.defaultSort = this.getDefaultSort();
    },
    mounted() {
        // 创建防抖函数并保存引用
        this.debouncedSetTableHeight = this._debounce(() => {
            this.setTableHeight();
        }, 200);

        this.$nextTick(() => {
            if (this.$refs.tableWrapper) {
                this.setTableHeight();
                window.addEventListener('resize', this.debouncedSetTableHeight);
            }
        })
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        setTableHeight() {
            if (this.$refs.tableWrapper) {
                this.tableHeight = this.$refs.tableWrapper.$el.clientHeight - 40;
            }
        },
        _debounce(func, delay) {
            let timer;
            const debounced = (...args) => {
                clearTimeout(timer);
                timer = setTimeout(() => func.apply(this, args), delay);
            };
            // 添加 cancel 方法用于手动清除定时器
            debounced.cancel = () => clearTimeout(timer);
            return debounced;
        },
        handleStartDateChange(value) {
            if (!value) {
                this.params.end_time = undefined;
            }
            this.params.begin_time = value;
        },
        handleEndDateChange(value) {
            this.params.end_time = value;
        },
        getEndTime(time) {
            if (!(time instanceof Date) || isNaN(time.getTime())) return '';
            return time.getTime() + (24 * 60 * 60 * 1000 - 1);
        },
        disableStartDate(time) { // 复用的开始时间禁用逻辑
            const disabledEndDate = this.params.end_time ? new Date(this.params.end_time) : null;
            if (disabledEndDate && time) {
                time = new Date(time);
                return disabledEndDate && time.getTime() > disabledEndDate.getTime()
            }
            return false
        },
        disableEndDate(time) { // 复用的结束时间禁用逻辑
            const disabledStartDate = this.params.begin_time ? new Date(this.params.begin_time) : null;
            if (disabledStartDate && time) {
                time = new Date(time);
                return disabledStartDate && time.getTime() < disabledStartDate.getTime()
            }
            return false
        },
        search({beforeSearch} = {}) {
            //  搜索时重置页码
            this.page.page_number = 1

            // 处理时间参数
            const {begin_time, end_time} = this.params
            const formattedBegin = begin_time ? this.$common.formatTimestampLongZone(begin_time) : null
            const formattedEnd = end_time ? this.$common.formatTimestampLongZone(this.getEndTime(end_time)) : null

            if (formattedBegin && !formattedEnd) {
                this.$message.error('结束时间不能为空')
                return
            }

            if (formattedBegin && formattedEnd && formattedBegin > formattedEnd) {
                this.$message.error('开始时间不能大于结束时间')
                return
            }

            this.fetchParams = this.filterParams({
                ...this.params,
                ...this.page,
                begin_time: formattedBegin,
                end_time: formattedEnd
            })

            try {
                if (typeof beforeSearch === 'function') beforeSearch(this.fetchParams);
            } catch (error) {
                console.error('beforeSearch 回调异常:', error);
            }

            this.getList()
        },
        handleSizeChange(val = 20) {
            const safeVal = typeof val === 'number' && !isNaN(val) ? val : 20;
            const validSizes = this.pageSizes;
            const clampedVal = validSizes.includes(safeVal) ? safeVal : validSizes.reduce((prev, curr) =>
                Math.abs(curr - safeVal) < Math.abs(prev - safeVal) ? curr : prev
            );

            if (this.page.page_size === clampedVal) return;

            this.page.page_number = 1;
            this.page.page_size = clampedVal;
            this.getList();
        },
        handleCurrentChange(val = 1) {
            const safeVal = typeof val === 'number' ? val : 1;
            const maxPageNum = this.page.page_size === 0
                ? 1
                : Math.max(1, Math.ceil(this.totalCount / this.page.page_size));

            // 计算最终页码
            const newPageNum = Math.min(safeVal, maxPageNum);
            // 页码无变化时不触发请求
            if (this.page.page_number === newPageNum) return;

            //  防止页码超出范围
            this.page.page_number = newPageNum;
            this.getList();
        },
        // 过滤空参数
        filterParams(params) {
            return Object.entries(params).reduce((acc, [key, value]) => {
                // 保留 0、false 等有效值
                if (value !== null && value !== '') acc[key] = value;
                return acc;
            }, {});
        },
        // 排序
        handleSortChange({column, prop, order}) {
            // 单字段排序模式下清空现有排序
            if (!this.multiSort) {
                this.params.sort_fields = "";
            }

            // 将字符串转换为数组进行操作
            let fields = this.params.sort_fields ? this.params.sort_fields.split(',') : [];

            // 查找相同prop的索引
            const index = fields.findIndex(field => {
                const cleanField = field.startsWith('-') ? field.slice(1) : field;
                return cleanField === prop;
            });

            // 处理不同排序状态
            if (order === null) {
                // 移除字段
                if (index > -1) {
                    fields.splice(index, 1);
                }
            } else {
                // 构建新字段
                const newField = order === "ascending" ? prop : `-${prop}`;

                // 替换或新增
                if (index > -1) {
                    fields[index] = newField;
                } else {
                    fields.push(newField);
                }
            }

            // 更新参数并触发响应式更新
            this.$set(this.params, 'sort_fields', fields.join(','));
            this.$set(this.fetchParams, 'sort_fields', fields.join(','));
            this.getList();
        },
        // 切换多字段排序模式
        toggleMultiSort() {
            this.multiSort = !this.multiSort;

            // 单字段模式下只保留第一个排序字段
            if (!this.multiSort && this.params.sort_fields) {
                const fields = this.params.sort_fields.split(',');
                if (fields.length > 1) {
                    this.$set(this.params, 'sort_fields', fields[0]);
                    this.$set(this.fetchParams, 'sort_fields', fields[0]);
                }
            }
        },
        getDefaultSort() {
            if (!this.params.sort_fields) return null;

            const fields = this.params.sort_fields.split(',');
            if (!fields.length || !fields[0]) return null;

            const field = fields[0];
            return {
                prop: field.startsWith('-') ? field.slice(1) : field,
                order: field.startsWith('-') ? 'descending' : 'ascending'
            };
        },
        handleParamsUpdate(formData) {
            // 推荐使用展开运算符进行响应式更新
            Object.keys(formData).forEach(key => {
                this.$set(this.params, key, formData[key]);
            });
        },
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setTableHeight);
        // 清除防抖定时器
        if (this.debouncedSetTableHeight && typeof this.debouncedSetTableHeight.cancel === 'function') {
            this.debouncedSetTableHeight.cancel();
        }
    }
}
